export default "__VITE_ASSET__OxtA69lh__"